/* NORTHGATE gate: the store is dark. Your cursor (or finger) is a flashlight.
   Letters of a hidden word sit somewhere in the dark; hold the light on one to take it.
   Find them all and you're tagged first in line. Tap the dark to fire a camera flash. */
(function () {
  if (window.__ngGate) return;
  window.__ngGate = 1;
  var D = document, root = D.querySelector('[data-ng-gate]');
  if (!root) return;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE = window.matchMedia && matchMedia('(pointer: coarse)').matches;
  function sfx(t, v) { try { window.dispatchEvent(new CustomEvent('ng:sfx', { detail: { t: t, v: v } })); } catch (_) {} }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var dark = root.querySelector('.gw-dark'), world = root.querySelector('.gw-world'), hit = root.querySelector('.gw-hit');
  var flashEl = root.querySelector('.gw-flash'), live = root.querySelector('[data-gw-live]');
  var hintEl = root.querySelector('[data-gw-hint]');

  /* ---------- flashlight ---------- */
  var W = innerWidth, H = innerHeight;
  var lx = W / 2, ly = H * 0.42, tx = lx, ty = ly, lastMove = -1e9, t0 = performance.now();
  var R = 1, rT = 1, flick = 0;
  function baseR() { return Math.min(Math.max(Math.min(W, H) * 0.24, 130), 230); }
  function sizeDark() { W = innerWidth; H = innerHeight; root.style.setProperty('--gw-r', baseR().toFixed(0) + 'px'); }
  sizeDark();
  addEventListener('resize', function () { sizeDark(); place(); });

  function aim(x, y, jump) { tx = x; ty = y; lastMove = performance.now(); if (jump) { lx = x; ly = y; } }
  D.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'mouse' || held) aim(e.clientX, e.clientY, false);
  }, { passive: true });
  var held = false, downAt = null;
  hit.addEventListener('pointerdown', function (e) {
    held = true; downAt = { x: e.clientX, y: e.clientY, t: performance.now() };
    aim(e.clientX, e.clientY, e.pointerType !== 'mouse');
    try { hit.setPointerCapture(e.pointerId); } catch (_) {}
  });
  function up(e) {
    if (!held) return;
    held = false;
    if (downAt && Math.hypot(e.clientX - downAt.x, e.clientY - downAt.y) < 10 && performance.now() - downAt.t < 350) flash();
    downAt = null;
  }
  hit.addEventListener('pointerup', up);
  hit.addEventListener('pointercancel', function () { held = false; downAt = null; });

  /* ---------- camera flash ---------- */
  var lastFlash = 0;
  function flash() {
    var now = performance.now();
    if (now - lastFlash < 2200) return;
    lastFlash = now;
    sfx('shutter', 1);
    root.classList.add('is-flash');
    if (!RM) { flashEl.classList.remove('go'); void flashEl.offsetWidth; flashEl.classList.add('go'); }
    setTimeout(function () { root.classList.remove('is-flash'); }, 110);
  }

  /* ---------- the hunt ---------- */
  var word = (root.getAttribute('data-word') || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 8);
  var unlock = root.getAttribute('data-unlock') === 'true';
  /* the hunt starts fresh every visit, so the game is always there and the piece stays hidden until it's won */
  var got = [];
  try { localStorage.removeItem('ng-hunt'); } catch (_) {}
  function emit(n, d) { try { window.dispatchEvent(new CustomEvent(n, { detail: d })); } catch (_) {} }
  /* nothing can be found while the press-to-enter screen is still up */
  var waiting = !!D.getElementById('ng-enter') && !D.getElementById('ng-enter').hidden;
  addEventListener('ng:enter', function () {
    waiting = false;
    aim(W / 2, H * 0.42, true);
    lastMove = performance.now();
    sfx('tick', 0.8);
  });
  var slots = Array.prototype.slice.call(root.querySelectorAll('.gw-slot'));
  var letters = [];
  if (word) {
    word.split('').forEach(function (ch, i) {
      var el = D.createElement('span');
      el.className = 'gw-letter';
      el.textContent = ch;
      el.style.setProperty('--rot', ((Math.random() * 2 - 1) * 14).toFixed(1) + 'deg');
      world.appendChild(el);
      letters.push({ el: el, i: i, ch: ch, acc: 0, x: 0, y: 0, done: false });
    });
  }
  /* scatter the letters where the interface isn't */
  function place() {
    var blocks = Array.prototype.map.call(root.querySelectorAll('[data-gw-avoid]'), function (b) { return b.getBoundingClientRect(); });
    var pts = [], pad2 = 56, mind = Math.min(W, H) * 0.22;
    letters.forEach(function (L) {
      var best = null, bestScore = -1;
      for (var k = 0; k < 160; k++) {
        var x = 40 + Math.random() * (W - 80), y = 70 + Math.random() * (H - 140);
        var bad = blocks.some(function (r) { return x > r.left - pad2 && x < r.right + pad2 && y > r.top - pad2 && y < r.bottom + pad2; });
        if (bad) continue;
        var d = pts.reduce(function (m, p) { return Math.min(m, Math.hypot(p[0] - x, p[1] - y)); }, 1e9);
        if (d > mind) { best = [x, y]; break; }
        if (d > bestScore) { bestScore = d; best = [x, y]; }
      }
      if (!best) best = [40 + Math.random() * (W - 80), 80 + Math.random() * (H * 0.4)];
      pts.push(best);
      L.x = best[0]; L.y = best[1];
      L.el.style.left = (best[0] / W * 100).toFixed(2) + '%';
      L.el.style.top = (best[1] / H * 100).toFixed(2) + '%';
    });
  }
  place();
  /* fonts and layout can shift once things load */
  setTimeout(place, 600);

  function fill(i, anim) {
    var s = slots[i];
    if (!s) return;
    s.textContent = word[i];
    s.classList.add('got');
    if (anim && !RM) { s.classList.remove('pop'); void s.offsetWidth; s.classList.add('pop'); }
  }
  function say(t) { if (live) live.textContent = t; }
  function take(L) {
    L.done = true;
    L.el.classList.add('got');
    got.push(L.i);
    fill(L.i, true);
    emit('ng:hunt', { found: got.length, total: letters.length });
    sfx('dub', 0.9);
    var left = letters.filter(function (o) { return !o.done; }).length;
    say(left ? 'found one. ' + left + ' to go.' : 'all found.');
    if (!left) setTimeout(complete, 380);
  }
  var completed = false;
  function complete() {
    if (completed) return;
    completed = true;
    root.classList.add('is-found');
    emit('ng:won', { total: letters.length });
    sfx('shimmer', 1);
    setTimeout(function () { sfx('thunder', 0.8); }, 160);
    if (hintEl) hintEl.textContent = root.getAttribute('data-found-line') || 'you found it. first in line.';
    reveal(false);
    var tags = root.querySelector('input[name="contact[tags]"]');
    if (tags) tags.value = 'club, found-the-key';
    var em = root.querySelector('input[name="contact[email]"]');
    if (em) em.placeholder = 'email — first in line';
    if (unlock) {
      var pw = root.querySelector('input[name="password"]'), det = root.querySelector('.gw-key');
      if (pw) {
        if (det) det.open = true;
        pw.value = word;
        setTimeout(function () { if (pw.form) pw.form.submit(); }, 3600);
      }
    }
  }
  /* lights stutter on like an old tube, then the piece glitches in */
  function reveal(quiet) {
    if (root.classList.contains('is-lit')) return;
    if (quiet || RM) { root.classList.add('is-lit', 'is-static'); return; }
    var steps = [[0, 0.05], [80, 1], [150, 0.35], [240, 1], [330, 0.1], [420, 0.75], [520, 0]];
    dark.style.transition = 'none';
    steps.forEach(function (s) { setTimeout(function () { dark.style.opacity = String(s[1]); }, s[0]); });
    setTimeout(function () {
      root.classList.add('is-lit');
      flashEl.classList.remove('go'); void flashEl.offsetWidth; flashEl.classList.add('go');
      sfx('zap', 1);
    }, 560);
  }

  /* ---------- countdown ---------- */
  var cd = root.querySelector('[data-gw-count]'), drop = parseInt(root.getAttribute('data-drop'), 10);
  var parts = cd ? { d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'), m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]') } : null;
  function count() {
    if (!cd || !drop) return;
    var left = Math.floor(drop - Date.now() / 1000);
    if (left <= 0) { cd.classList.add('is-now'); cd.setAttribute('aria-label', 'any minute now'); return; }
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    parts.d.textContent = pad(d); parts.h.textContent = pad(h); parts.m.textContent = pad(m); parts.s.textContent = pad(s);
    cd.setAttribute('aria-label', d + ' days ' + h + ' hours ' + m + ' minutes until the drop');
    if (!RM) { parts.s.classList.remove('tk'); void parts.s.offsetWidth; parts.s.classList.add('tk'); }
  }
  if (cd && drop) { cd.hidden = false; count(); setInterval(count, 1000); }

  /* ---------- wrong key: open the key drawer so they see the message ---------- */
  if (root.querySelector('[data-gw-wrong]')) { var kd = root.querySelector('.gw-key'); if (kd) kd.open = true; sfx('thud', 0.6); }

  /* ---------- loop ---------- */
  var last = performance.now(), fl = 0;
  function loop(now) {
    var dt = Math.min((now - last) / 1000, 1 / 20); last = now;
    var idle = now - lastMove > (COARSE ? 2600 : 3800);
    if (idle && !RM) {
      var t = (now - t0) / 1000;
      tx = W * (0.5 + 0.34 * Math.sin(t * 0.31)); ty = H * (0.42 + 0.26 * Math.sin(t * 0.47 + 1.3));
    }
    var k = idle ? 1 - Math.pow(0.35, dt) : 1 - Math.pow(0.0005, dt);
    lx += (tx - lx) * k; ly += (ty - ly) * k;
    /* stepped flicker, like a cheap torch */
    if (!RM && now - fl > 70) {
      fl = now;
      var r = Math.random();
      rT = r < 0.04 ? 0.72 : r < 0.12 ? 0.94 : 1 + (Math.random() - 0.5) * 0.04;
    }
    R = RM ? 1 : rT;
    dark.style.transform = 'translate3d(' + lx.toFixed(1) + 'px,' + ly.toFixed(1) + 'px,0) scale(' + R.toFixed(3) + ')';
    /* letters warm up while the light sits on them */
    var core = baseR() * 0.5;
    for (var i = 0; i < letters.length; i++) {
      var L = letters[i];
      if (L.done) continue;
      var lit = !idle && !waiting && Math.hypot(L.x - lx, L.y - ly) < core;
      if (lit) {
        if (L.acc === 0) sfx('tick', 0.3);
        L.acc += dt;
        L.el.classList.add('warm');
        if (L.acc > 0.6) take(L);
      } else if (L.acc > 0) {
        L.acc = Math.max(0, L.acc - dt * 2);
        if (!L.acc) L.el.classList.remove('warm');
      }
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();
